export const DEFAULT_POPUP_FEATURES = {
    location: 'no',
    toolbar: 'no',
    width: 500,
    height: 645,
    left: 100,
    top: 100,
};
export class OAuthPopup {
    open(url, popupFeatures = DEFAULT_POPUP_FEATURES) {
        if (this.isPopupOpen() && this.promise) {
            // Focus existing popup if it exists
            this.popup.focus();
            return this.promise;
        }
        this.promise = new Promise((res, rej) => {
            this.resolve = res;
            this.reject = rej;
        });
        this.popup = window.open(url, '_blank', featuresFromObject(popupFeatures));
        // Create a callback that the popup can call
        window.OAuthPopupCallback = params => {
            this.close();
            this.resolve(params);
        };
        this.addCloseListener();
        return this.promise;
    }
    close() {
        this.popup && this.popup.close();
        clearInterval(this.closeInterval);
    }
    isPopupOpen() {
        return this.popup && !this.popup.closed;
    }
    addCloseListener() {
        this.closeInterval = setInterval(() => {
            if (!this.isPopupOpen()) {
                clearInterval(this.closeInterval);
                this.reject(new Error('Popup was closed before authentication was completed.'));
            }
        }, 50);
    }
    /**
     * Returns true if we're currently in a popup window
     */
    static isPopupWindow() {
        return !!this.getCallback();
    }
    static getCallback() {
        try {
            // This will throw an exception when the site was opened from another origin
            const callback = window.opener && window.opener.OAuthPopupCallback;
            return callback || null;
        }
        catch (e) {
            return null;
        }
    }
    static notifyOpener(params) {
        const callback = this.getCallback();
        if (callback === null) {
            return false;
        }
        callback(params);
        return true;
    }
}
const featuresFromObject = features => {
    return Object.keys(features)
        .map(key => `${key}=${features[key]}`)
        .join(',');
};
